import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetTiers = () => {
  const get = useTypedApiClient({
    path: '/admin/tiers',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/tiers'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
